import { z } from 'zod';

import { EmailCapturePage } from '@portal/types/studio/studio';
import { HeaderContextData } from '@portal/state/context/HeaderContext';
import { FooterData } from '@portal/types/studio/footer';

export const formSchema = z.object({
  email: z.string().email({ message: 'Please enter a valid Email Address' }),
  email_consent: z
    .boolean()
    .default(false)
    .refine((arg) => !!arg)
});

export type FormValue = z.infer<typeof formSchema>;

export type EmailCapturePageProps = {
  pageData: EmailCapturePage;
  headerData: HeaderContextData;
  footerData: FooterData;
};
